import axios from "axios";
import { SERVER_URL } from "config";
import { authHeader } from "_helpers";

function getCompanyAcquireCampaigns(params) {
  const endpoint = `${SERVER_URL}/api/v2/my-organization/proactive/social/metrics/campaigns`;
  return axios.get(endpoint, {
    params: params,
    headers: authHeader(),
  });
}

function getCompanyAcquireMetrics(params) {
  const endpoint = `${SERVER_URL}/api/v2/my-organization/proactive/social/metrics/summary`;
  return axios.get(endpoint, {
    params: params,
    headers: authHeader(),
  });
}

function getOrganizationAcquireCampaigns(organizationId, params) {
  const endpoint = `${SERVER_URL}/api/v2/organizations/${organizationId}/proactive/social/metrics/campaigns`;
  return axios.get(endpoint, {
    params,
    headers: authHeader(),
  });
}

function getOrganizationAcquireMetrics(organizationId, params) {
  const endpoint = `${SERVER_URL}/api/v2/organizations/${organizationId}/proactive/social/metrics/summary`;
  return axios.get(endpoint, {
    params,
    headers: authHeader(),
  });
}

export const acquireService = {
  getCompanyAcquireCampaigns,
  getCompanyAcquireMetrics,
  getOrganizationAcquireCampaigns,
  getOrganizationAcquireMetrics,
};
